import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.VUE_APP_APP_INSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: true,
  },
});

appInsights.loadAppInsights();

export default appInsights;